/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invalidvatiderror3Inputs */

const en_invalidvatiderror3 = /** @type {(inputs: Invalidvatiderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This VAT ID is not valid. Please check it in your billing details.`)
};

const de_invalidvatiderror3 = /** @type {(inputs: Invalidvatiderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese UID-Nummer ist ungültig. Bitte prüfe sie in deinen Rechnungsdaten.`)
};

/**
* | output |
* | --- |
* | "This VAT ID is not valid. Please check it in your billing details." |
*
* @param {Invalidvatiderror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const invalidvatiderror3 = /** @type {((inputs?: Invalidvatiderror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invalidvatiderror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invalidvatiderror3(inputs)
	return de_invalidvatiderror3(inputs)
});
export { invalidvatiderror3 as "invalidVatIdError" }